import './routing-legend.css';

import h from 'hyperscript';
import duration
  from '@disy/cadenza-icons/routing-mini-legend-stopwatch.svg';
import distance from '@disy/cadenza-icons/routing-distance.svg';

import { icon } from 'cadenza/utils/icon/icon';
import { getIconForProfile, renderAvoidanceCount } from 'cadenza/map/legend/routing-legend-utils';

export function renderRouteLegend (layerLegendElement) {
  return [ h('.legend-element', createEntries(layerLegendElement.entries)) ];
}

function createEntries (entries) {
  return entries.map(entry => {
    const classification = h('.classification-color', {
      style: { 'background-color': entry.color }
    });
    const elements = [
      h('span.classification', classification),
      getIconForProfile(entry.profile),
      h('span.duration', [ icon(duration), h('span', entry.duration) ]),
      h('span.distance', [ icon(distance), h('span', entry.distance) ]),
      renderAvoidanceCount(entry.avoidanceCount)
    ];

    return h('.legend-element-entry', elements);
  });
}
